(function () {
  'use strict';

  function initRoleSlider() {
    if (typeof Swiper === 'undefined') {
      setTimeout(initRoleSlider, 500);
      return;
    }

    var container = document.querySelector('.ncg-choose-role__swiper');
    if (!container || container.classList.contains('swiper-initialized')) return;

    var totalSlides = container.querySelectorAll('.ncg-choose-role__slide').length;

    function shouldEnableSlider() {
      if (window.innerWidth < 1200) return true;
      return totalSlides > 4;
    }

    var enableSlider = shouldEnableSlider();

    if (!enableSlider) {
      var controls = document.querySelector('.ncg-choose-role__controls');
      if (controls) controls.style.display = 'none';
      container.classList.add('ncg-choose-role__swiper--static');
      container.classList.add('swiper-initialized');
      initCardInteractions();
      return;
    }

    var swiper = new Swiper(container, {
      slideClass: 'ncg-choose-role__slide',
      wrapperClass: 'ncg-choose-role__wrapper',

      slidesPerView: 'auto',
      spaceBetween: 24,
      loop: totalSlides > 4,
      speed: 600,
      grabCursor: true,

      navigation: {
        nextEl: '.ncg-choose-role__arrow--next',
        prevEl: '.ncg-choose-role__arrow--prev'
      },

      breakpoints: {
        0: {
          spaceBetween: 12
        },
        750: {
          spaceBetween: 24
        }
      },

      on: {
        init: function () {
          updatePagination(this);
        },
        slideChange: function () {
          updatePagination(this);
          closeAllCards();
        }
      }
    });

    function updatePagination(swiperInstance) {
      var paginationEl = document.querySelector('.ncg-choose-role__pagination');
      if (!paginationEl) return;
      var current = swiperInstance.realIndex + 1;
      paginationEl.textContent = current + '/' + totalSlides;
    }

    var slider = document.querySelector('.ncg-choose-role-slider');
    var prevBtn = document.querySelector('.ncg-choose-role__arrow--prev');
    var nextBtn = document.querySelector('.ncg-choose-role__arrow--next');

    function disableHoverTemporarily() {
      if (!slider) return;
      slider.classList.add('ncg-hover-disabled');
      var enableOnMove = function () {
        slider.classList.remove('ncg-hover-disabled');
        document.removeEventListener('mousemove', enableOnMove);
      };
      document.addEventListener('mousemove', enableOnMove);
    }

    if (prevBtn) prevBtn.addEventListener('click', disableHoverTemporarily);
    if (nextBtn) nextBtn.addEventListener('click', disableHoverTemporarily);

    window.ncgRoleSlider = swiper;
    container.classList.add('swiper-initialized');

    initCardInteractions();
  }

  function closeAllCards() {
    var cards = document.querySelectorAll('.ncg-choose-role__card.is-active');
    cards.forEach(function (card) {
      card.classList.remove('is-active');
    });
  }

  function initCardInteractions() {
    var cards = document.querySelectorAll('.ncg-choose-role__card');

    cards.forEach(function (card) {
      if (card.dataset.ncgInit === 'true') return;
      card.dataset.ncgInit = 'true';

      card.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        var isActive = card.classList.contains('is-active');
        closeAllCards();
        if (!isActive) {
          card.classList.add('is-active');
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.ncg-choose-role__card')) {
        closeAllCards();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRoleSlider);
  } else {
    initRoleSlider();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (
      e.target.classList.contains('ncg-choose-role-slider') ||
      e.target.querySelector('.ncg-choose-role-slider')
    ) {
      var container = document.querySelector('.ncg-choose-role__swiper');
      if (container) {
        container.classList.remove('swiper-initialized');
        container.classList.remove('ncg-choose-role__swiper--static');
      }
      document.querySelectorAll('.ncg-choose-role__card').forEach(function (c) {
        delete c.dataset.ncgInit;
      });
      initRoleSlider();
    }
  });
})();